/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { PlatformDetectorService } from 'crimson/lib/platform-detector/platform-detector.service';

@Injectable({
    providedIn: 'root'
})
export class WlsHelperService {
    private windowLocalStorage: Storage = null;

    constructor() {
        if (PlatformDetectorService.isBrowserPlatform()) {
            this.windowLocalStorage = window.localStorage;
        }
    }

    // localstorage
    getWlsItem(storeName, key): any {
        return this.windowLocalStorage && JSON.parse(this.windowLocalStorage.getItem(storeName + key));
    }

    setWlsItem(storeName, key, item): any {
        return this.windowLocalStorage && this.windowLocalStorage.setItem(storeName + key, JSON.stringify(item));
    }

    removeWlsItem(storeName, key): any {
        return this.windowLocalStorage && this.windowLocalStorage.removeItem(storeName + key);
    }

    getLength(): number {
        return this.windowLocalStorage && this.windowLocalStorage.length;
    }

    getKey(index: number): string {
        return this.windowLocalStorage && this.windowLocalStorage.key(index);
    }

    clearall(storeName): any {
        if (this.windowLocalStorage) {
            Object.keys(this.windowLocalStorage)?.forEach(key => {
                if (key?.startsWith(storeName)) {
                    this.windowLocalStorage.removeItem(key);
                }
            });
        }
    }
}
